module.exports = __webpack_public_path__ + "img/DrySystem-Info.4c26f0bb.jpg";